import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ContactAppResource from "./ContactAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";
import ExternalUserAppResource from "./ExternalUserAppResource";
import ConnectorAppResource from "./ConnectorAppResource";
import HubExternalLoanAppResource from "./HubExternalLoanAppResource";

class ExternalLoanAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'External-Loan';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'externals/loans';
    }

    /**
     *
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'connectorUuid',
            'organizationUuid',
            'ownerId',
            'borrowerId',
            'coBorrowerId',
            'buyerAgentId',
            'sellerAgentId',
            'externalLoanId',
            'loanStatus',
            'loanAmount',
            'loanRate',
            'loanTerm',
            'purchasePrice',
            'city',
            'state',
            'address',
            'zipCode',
            'externalData',
            'address2',
            'loanName',
            'propertyType',
            'approvalDate',
            'closingDate',
            'closingDateEstimated',
        ];
    }


    relationMap() {
        return {
            'connector': ConnectorAppResource,
            'externalUser': ExternalUserAppResource,
            'organizationMember': OrganizationMemberAppResource,
            'borrowerContact': ContactAppResource,
            'coBorrowerContact': ContactAppResource,
            'sellerAgentContact': ContactAppResource,
            'buyerAgentContact': ContactAppResource,
            'loanHubs': HubExternalLoanAppResource,
        }
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {

    }

    validationRules() {
        return {
            createdDate: {
                type: 'string',
                datetime: true,
            },
            address: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            address2: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            city: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            state: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default ExternalLoanAppResource;
